import * as React from 'react';
import { useContext, useMemo } from 'react';
import { Baggage } from '../../../BaggageService/types';
import BaggageIcon from './BaggageIcon/BaggageIcon';
import { useTheme } from '../../../theme';
import cn from 'classnames';
import { useRenderers } from '../../../renderProps';
import { BaggageContext } from '../../context';

export interface Props {
	baggage: Baggage;
	selected?: boolean;
	realIconSize?: boolean;
	onlyIcon?: boolean;
	short?: boolean;
	iconClassName?: string;
}

export type BaggageIconProps = React.ComponentProps<typeof BaggageIcon>;

const Baggage: React.FC<Props> = ({ baggage, selected, realIconSize = false, onlyIcon, short, iconClassName }) => {
	const { Baggage: css } = useTheme('Baggage');

	const baggageIconProps: BaggageIconProps = useMemo(
		() => ({
			baggage,
			className: cn(css.icon, iconClassName),
			realSize: realIconSize,
			onlyIcon
		}),
		[baggage, iconClassName, onlyIcon, realIconSize]
	);

	const baggageIconClickHandler = useContext(BaggageContext)?.onBaggageIconClick;
	const { BaggageIcon: BaggageIconOverride = BaggageIcon } = useRenderers();

	return (
		<div
			className={cn(css.root, {
				[css.selected]: selected,
				[css.short]: short
			})}
		>
			<div className={baggageIconClickHandler ? css.iconWrapper_pointer : null} onClick={baggageIconClickHandler}>
				<BaggageIconOverride {...baggageIconProps} />
			</div>

			{!short && (
				<>
					<div className={css.name}>{baggage.name}</div>
					<div className={css.size}>{baggage.size}</div>
				</>
			)}
		</div>
	);
};

export default Baggage;
